import { createContext } from 'react';

interface UserAgentContextProps {
  isMobile?: boolean;
  isDesktop?: boolean;
  isTablet?: boolean;
  isIosOrSafari?: boolean;
  deviceCategory?: 'desktop' | 'mobile';
}
export const UserAgentContext = createContext<UserAgentContextProps | null>(null);
